<template>
  <div id="validacion-registra">
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-layout align-center justify-center>
      <v-flex lg10>
        <v-card>
          <v-container>
            <v-form>
              <v-container>
                <v-layout>
                  <v-flex>
                    <!-- INICIO DATOS DE VISITA PADRE -->
                    <data-recepcion
                      v-if="tipeView != 'consulta'"
                      :id="id"
                      :tipeView="tipeView"
                    ></data-recepcion>
                    <!-- TERMINO DATOS DE VISITA -->
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Vue from "vue";
import DataRecepcion from "@/modules/aplicacion/views/recepcion/RecepcionData.vue";

import axios from "axios";

export default {
  name: "recepcion-registra",
  components: {
    DataRecepcion,
  },
  props: {
    proveedor: {},
    show: Boolean,
    tipo: "",
  },

  data: () => ({
    id: "",
    documentoId: "",
    tipeView: "",
  }),

  computed: {},
  mounted() {},
  created() {
    this.idSubitem = this.$route.params.idSubitem;
    this.idAcuerdo = this.$route.params.idAcuerdo;
  },

  methods: {
    volver() {
      setTimeout(() => {
        this.$router.push({
          name: "FormRecepcion",
          params: {
            tipeView: "consulta",
            idSubitem: this.idSubitem,
            idAcuerdo: this.idAcuerdo,
          },
        });
      }, 1000);
    },
  },
};
</script>
